<template>
  <div id="paginaCostoSpettacolo">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Selezione Spettacolo</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown
              variant="link"
              no-caret
              right
              class="chart-dropdown"
              toggle-class="p-0"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item href="#"> ... </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropStagioni"
                  ref="dropStagioni"
                  :query="queryStagioni"
                  :dataSource="stagioniData"
                  :index="stagioniIndex"
                  :fields="stagioniFields"
                  :change="onStagioneChange"
                  v-model="stagioneCorrente"
                  placeholder="Seleziona un Anno"
                ></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropSpettacoli"
                  ref="dropSpettacoli"
                  :query="querySpettacoli"
                  :dataSource="elencoSpettacoliList"
                  :index="spettacoliIndex"
                  :fields="elencoSpettacoliFields"
                  :enabled="dropSpettacoliEnabled"
                  :change="onSpettacoloChange"
                  v-model="spettacoloCorrente"
                  placeholder="Seleziona uno Spettacolo"
                ></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
              <b-col xl="12" md="12" class="pt-1"> </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-show="showCostiSpettacolo">
      <b-col xl="12" md="12" v-show="showRiepilogo">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Riepilogo</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>

            <!-- Input di tipo checkbox: conteggiaInCostiTotali.aiutoSarta -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="aiutoSarta"
                  v-model="conteggiaInCostiTotali.aiutoSarta"
                  :checked="conteggiaInCostiTotali.aiutoSarta"
                  :change="aggiornaCostoTotale"
                  name="aiutoSarta"
                /> &nbsp &nbsp
                <label for="aiutoSarta" class="h5 mr-1"
                  >Aiuto Sarta</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.aiutoScenografo -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="aiutoScenografo"
                  v-model="conteggiaInCostiTotali.aiutoScenografo"
                  :checked="conteggiaInCostiTotali.aiutoScenografo"
                  :change="aggiornaCostoTotale"
                  name="aiutoScenografo"
                /> &nbsp &nbsp
                <label for="aiutoScenografo" class="h5 mr-1"
                  >Aiuto Scenografo</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.aiutoTruccoParrucco -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="aiutoTruccoParrucco"
                  v-model="conteggiaInCostiTotali.aiutoTruccoParrucco"
                  :checked="conteggiaInCostiTotali.aiutoTruccoParrucco"
                  :change="aggiornaCostoTotale"
                  name="aiutoTruccoParrucco"
                /> &nbsp &nbsp
                <label for="aiutoTruccoParrucco" class="h5 mr-1"
                  >Aiuto Trucco e Parrucco</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.alloggio -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="alloggio"
                  v-model="conteggiaInCostiTotali.alloggio"
                  :checked="conteggiaInCostiTotali.alloggio"
                  :change="aggiornaCostoTotale"
                  name="alloggio"
                /> &nbsp &nbsp
                <label for="alloggio" class="h5 mr-1"
                  >Alloggio</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.altriDiritti -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="altriDiritti"
                  v-model="conteggiaInCostiTotali.altriDiritti"
                  :checked="conteggiaInCostiTotali.altriDiritti"
                  :change="aggiornaCostoTotale"
                  name="altriDiritti"
                /> &nbsp &nbsp
                <label for="altriDiritti" class="h5 mr-1"
                  >Altri Diritti</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.altro -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="altro"
                  v-model="conteggiaInCostiTotali.altro"
                  :checked="conteggiaInCostiTotali.altro"
                  :change="aggiornaCostoTotale"
                  name="altro"
                /> &nbsp &nbsp
                <label for="altro" class="h5 mr-1"
                  >Altri Allestimenti</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.attrezzeria -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="attrezzeria"
                  v-model="conteggiaInCostiTotali.attrezzeria"
                  :checked="conteggiaInCostiTotali.attrezzeria"
                  :change="aggiornaCostoTotale"
                  name="attrezzeria"
                /> &nbsp &nbsp
                <label for="attrezzeria" class="h5 mr-1"
                  >Attrezzeria</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.attrezzista -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="attrezzista"
                  v-model="conteggiaInCostiTotali.attrezzista"
                  :checked="conteggiaInCostiTotali.attrezzista"
                  :change="aggiornaCostoTotale"
                  name="attrezzista"
                /> &nbsp &nbsp
                <label for="attrezzista" class="h5 mr-1"
                  >Attrezzista</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.calzature -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="calzature"
                  v-model="conteggiaInCostiTotali.calzature"
                  :checked="conteggiaInCostiTotali.calzature"
                  :change="aggiornaCostoTotale"
                  name="calzature"
                /> &nbsp &nbsp
                <label for="calzature" class="h5 mr-1"
                  >Calzature</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.cantanteLirico -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="cantanteLirico"
                  v-model="conteggiaInCostiTotali.cantanteLirico"
                  :checked="conteggiaInCostiTotali.cantanteLirico"
                  :change="aggiornaCostoTotale"
                  name="cantanteLirico"
                /> &nbsp &nbsp
                <label for="cantanteLirico" class="h5 mr-1"
                  >Cantante lirico</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.coreografo -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="coreografo"
                  v-model="conteggiaInCostiTotali.coreografo"
                  :checked="conteggiaInCostiTotali.coreografo"
                  :change="aggiornaCostoTotale"
                  name="coreografo"
                /> &nbsp &nbsp
                <label for="coreografo" class="h5 mr-1"
                  >Coreografo</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.coro -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="coro"
                  v-model="conteggiaInCostiTotali.coro"
                  :checked="conteggiaInCostiTotali.coro"
                  :change="aggiornaCostoTotale"
                  name="coro"
                /> &nbsp &nbsp
                <label for="coro" class="h5 mr-1"
                  >Coro</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.coroVociBianche -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="coroVociBianche"
                  v-model="conteggiaInCostiTotali.coroVociBianche"
                  :checked="conteggiaInCostiTotali.coroVociBianche"
                  :change="aggiornaCostoTotale"
                  name="coroVociBianche"
                /> &nbsp &nbsp
                <label for="coroVociBianche" class="h5 mr-1"
                  >Coro Voci Bianche</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.corpoBallo -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="corpoBallo"
                  v-model="conteggiaInCostiTotali.corpoBallo"
                  :checked="conteggiaInCostiTotali.corpoBallo"
                  :change="aggiornaCostoTotale"
                  name="corpoBallo"
                /> &nbsp &nbsp
                <label for="corpoBallo" class="h5 mr-1"
                  >Corpo di Ballo</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.costumi -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="costumi"
                  v-model="conteggiaInCostiTotali.costumi"
                  :checked="conteggiaInCostiTotali.costumi"
                  :change="aggiornaCostoTotale"
                  name="costumi"
                /> &nbsp &nbsp
                <label for="costumi" class="h5 mr-1"
                  >Costumi</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.costumista -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="costumista"
                  v-model="conteggiaInCostiTotali.costumista"
                  :checked="conteggiaInCostiTotali.costumista"
                  :change="aggiornaCostoTotale"
                  name="costumista"
                /> &nbsp &nbsp
                <label for="costumista" class="h5 mr-1"
                  >Costumista</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.danzatore -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="danzatore"
                  v-model="conteggiaInCostiTotali.danzatore"
                  :checked="conteggiaInCostiTotali.danzatore"
                  :change="aggiornaCostoTotale"
                  name="danzatore"
                /> &nbsp &nbsp
                <label for="danzatore" class="h5 mr-1"
                  >Danzatore</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.direttoreOrchestra -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="direttoreOrchestra"
                  v-model="conteggiaInCostiTotali.direttoreOrchestra"
                  :checked="conteggiaInCostiTotali.direttoreOrchestra"
                  :change="aggiornaCostoTotale"
                  name="direttoreOrchestra"
                /> &nbsp &nbsp
                <label for="direttoreOrchestra" class="h5 mr-1"
                  >Direttore d'Orchestra</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.direttoreScena -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="direttoreScena"
                  v-model="conteggiaInCostiTotali.direttoreScena"
                  :checked="conteggiaInCostiTotali.direttoreScena"
                  :change="aggiornaCostoTotale"
                  name="direttoreScena"
                /> &nbsp &nbsp
                <label for="direttoreScena" class="h5 mr-1"
                  >Direttore di Scena</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.dirittiCompositore -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="dirittiCompositore"
                  v-model="conteggiaInCostiTotali.dirittiCompositore"
                  :checked="conteggiaInCostiTotali.dirittiCompositore"
                  :change="aggiornaCostoTotale"
                  name="dirittiCompositore"
                /> &nbsp &nbsp
                <label for="dirittiCompositore" class="h5 mr-1"
                  >Diritti Compositore</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.dirittiCostumista -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="dirittiCostumista"
                  v-model="conteggiaInCostiTotali.dirittiCostumista"
                  :checked="conteggiaInCostiTotali.dirittiCostumista"
                  :change="aggiornaCostoTotale"
                  name="dirittiCostumista"
                /> &nbsp &nbsp
                <label for="dirittiCostumista" class="h5 mr-1"
                  >Diritti Costumista</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.dirittiLibrettista -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="dirittiLibrettista"
                  v-model="conteggiaInCostiTotali.dirittiLibrettista"
                  :checked="conteggiaInCostiTotali.dirittiLibrettista"
                  :change="aggiornaCostoTotale"
                  name="dirittiLibrettista"
                /> &nbsp &nbsp
                <label for="dirittiLibrettista" class="h5 mr-1"
                  >Diritti Librettista</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.dirittiLighting -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="dirittiLighting"
                  v-model="conteggiaInCostiTotali.dirittiLighting"
                  :checked="conteggiaInCostiTotali.dirittiLighting"
                  :change="aggiornaCostoTotale"
                  name="dirittiLighting"
                /> &nbsp &nbsp
                <label for="dirittiLighting" class="h5 mr-1"
                  >Diritti Lighting</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.dirittiRegia -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="dirittiRegia"
                  v-model="conteggiaInCostiTotali.dirittiRegia"
                  :checked="conteggiaInCostiTotali.dirittiRegia"
                  :change="aggiornaCostoTotale"
                  name="dirittiRegia"
                /> &nbsp &nbsp
                <label for="dirittiRegia" class="h5 mr-1"
                  >Diritti Regia</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.dirittiScenografo -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="dirittiScenografo"
                  v-model="conteggiaInCostiTotali.dirittiScenografo"
                  :checked="conteggiaInCostiTotali.dirittiScenografo"
                  :change="aggiornaCostoTotale"
                  name="dirittiScenografo"
                /> &nbsp &nbsp
                <label for="dirittiScenografo" class="h5 mr-1"
                  >Diritti Scenografo</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.drammaturgo -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="drammaturgo"
                  v-model="conteggiaInCostiTotali.drammaturgo"
                  :checked="conteggiaInCostiTotali.drammaturgo"
                  :change="aggiornaCostoTotale"
                  name="drammaturgo"
                /> &nbsp &nbsp
                <label for="drammaturgo" class="h5 mr-1"
                  >Drammaturgo</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.elettricista -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="elettricista"
                  v-model="conteggiaInCostiTotali.elettricista"
                  :checked="conteggiaInCostiTotali.elettricista"
                  :change="aggiornaCostoTotale"
                  name="elettricista"
                /> &nbsp &nbsp
                <label for="elettricista" class="h5 mr-1"
                  >Elettricista</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.ensembleOrchestrale -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="ensembleOrchestrale"
                  v-model="conteggiaInCostiTotali.ensembleOrchestrale"
                  :checked="conteggiaInCostiTotali.ensembleOrchestrale"
                  :change="aggiornaCostoTotale"
                  name="ensembleOrchestrale"
                /> &nbsp &nbsp
                <label for="ensembleOrchestrale" class="h5 mr-1"
                  >Ensemble Orchestrale</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.figurante -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="figurante"
                  v-model="conteggiaInCostiTotali.figurante"
                  :checked="conteggiaInCostiTotali.figurante"
                  :change="aggiornaCostoTotale"
                  name="figurante"
                /> &nbsp &nbsp
                <label for="figurante" class="h5 mr-1"
                  >Figurante</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.fonico -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="fonico"
                  v-model="conteggiaInCostiTotali.fonico"
                  :checked="conteggiaInCostiTotali.fonico"
                  :change="aggiornaCostoTotale"
                  name="fonico"
                /> &nbsp &nbsp
                <label for="fonico" class="h5 mr-1"
                  >Fonico</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.legname -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="legname"
                  v-model="conteggiaInCostiTotali.legname"
                  :checked="conteggiaInCostiTotali.legname"
                  :change="aggiornaCostoTotale"
                  name="legname"
                /> &nbsp &nbsp
                <label for="legname" class="h5 mr-1"
                  >Legname</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.librettista -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="librettista"
                  v-model="conteggiaInCostiTotali.librettista"
                  :checked="conteggiaInCostiTotali.librettista"
                  :change="aggiornaCostoTotale"
                  name="librettista"
                /> &nbsp &nbsp
                <label for="librettista" class="h5 mr-1"
                  >Librettista</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.lighting -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="lighting"
                  v-model="conteggiaInCostiTotali.lighting"
                  :checked="conteggiaInCostiTotali.lighting"
                  :change="aggiornaCostoTotale"
                  name="lighting"
                /> &nbsp &nbsp
                <label for="lighting" class="h5 mr-1"
                  >Lighting</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.luci -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="luci"
                  v-model="conteggiaInCostiTotali.luci"
                  :checked="conteggiaInCostiTotali.luci"
                  :change="aggiornaCostoTotale"
                  name="luci"
                /> &nbsp &nbsp
                <label for="luci" class="h5 mr-1"
                  >Luci</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.macchinista -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="macchinista"
                  v-model="conteggiaInCostiTotali.macchinista"
                  :checked="conteggiaInCostiTotali.macchinista"
                  :change="aggiornaCostoTotale"
                  name="macchinista"
                /> &nbsp &nbsp
                <label for="macchinista" class="h5 mr-1"
                  >Macchinista</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.maestroCollaboratore -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="maestroCollaboratore"
                  v-model="conteggiaInCostiTotali.maestroCollaboratore"
                  :checked="conteggiaInCostiTotali.maestroCollaboratore"
                  :change="aggiornaCostoTotale"
                  name="maestroCollaboratore"
                /> &nbsp &nbsp
                <label for="maestroCollaboratore" class="h5 mr-1"
                  >Maestro Collaboratore</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.maestroCoro -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="maestroCoro"
                  v-model="conteggiaInCostiTotali.maestroCoro"
                  :checked="conteggiaInCostiTotali.maestroCoro"
                  :change="aggiornaCostoTotale"
                  name="maestroCoro"
                /> &nbsp &nbsp
                <label for="maestroCoro" class="h5 mr-1"
                  >Maestro del Coro</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.maestroLuci -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="maestroLuci"
                  v-model="conteggiaInCostiTotali.maestroLuci"
                  :checked="conteggiaInCostiTotali.maestroLuci"
                  :change="aggiornaCostoTotale"
                  name="maestroLuci"
                /> &nbsp &nbsp
                <label for="maestroLuci" class="h5 mr-1"
                  >Maestro delle Luci</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.maestroPalco -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="maestroPalco"
                  v-model="conteggiaInCostiTotali.maestroPalco"
                  :checked="conteggiaInCostiTotali.maestroPalco"
                  :change="aggiornaCostoTotale"
                  name="maestroPalco"
                /> &nbsp &nbsp
                <label for="maestroPalco" class="h5 mr-1"
                  >Maestro del Palco</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.maestroSala -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="maestroSala"
                  v-model="conteggiaInCostiTotali.maestroSala"
                  :checked="conteggiaInCostiTotali.maestroSala"
                  :change="aggiornaCostoTotale"
                  name="maestroSala"
                /> &nbsp &nbsp
                <label for="maestroSala" class="h5 mr-1"
                  >Maestro di Sala</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.maestroSovratitoli -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="maestroSovratitoli"
                  v-model="conteggiaInCostiTotali.maestroSovratitoli"
                  :checked="conteggiaInCostiTotali.maestroSovratitoli"
                  :change="aggiornaCostoTotale"
                  name="maestroSovratitoli"
                /> &nbsp &nbsp
                <label for="maestroSovratitoli" class="h5 mr-1"
                  >Maestro dei Sovratitoli</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.materialeConsumo -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="materialeConsumo"
                  v-model="conteggiaInCostiTotali.materialeConsumo"
                  :checked="conteggiaInCostiTotali.materialeConsumo"
                  :change="aggiornaCostoTotale"
                  name="materialeConsumo"
                /> &nbsp &nbsp
                <label for="materialeConsumo" class="h5 mr-1"
                  >Materiale di Consumo</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.materialeElettrico -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="materialeElettrico"
                  v-model="conteggiaInCostiTotali.materialeElettrico"
                  :checked="conteggiaInCostiTotali.materialeElettrico"
                  :change="aggiornaCostoTotale"
                  name="materialeElettrico"
                /> &nbsp &nbsp
                <label for="materialeElettrico" class="h5 mr-1"
                  >Materiale Elettrico</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.materialeMusicale -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="materialeMusicale"
                  v-model="conteggiaInCostiTotali.materialeMusicale"
                  :checked="conteggiaInCostiTotali.materialeMusicale"
                  :change="aggiornaCostoTotale"
                  name="materialeMusicale"
                /> &nbsp &nbsp
                <label for="materialeMusicale" class="h5 mr-1"
                  >Materiale Musicale</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.musicologo -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="musicologo"
                  v-model="conteggiaInCostiTotali.musicologo"
                  :checked="conteggiaInCostiTotali.musicologo"
                  :change="aggiornaCostoTotale"
                  name="musicologo"
                /> &nbsp &nbsp
                <label for="musicologo" class="h5 mr-1"
                  >Musicologo</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.orchestra -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="orchestra"
                  v-model="conteggiaInCostiTotali.orchestra"
                  :checked="conteggiaInCostiTotali.orchestra"
                  :change="aggiornaCostoTotale"
                  name="orchestra"
                /> &nbsp &nbsp
                <label for="orchestra" class="h5 mr-1"
                  >Orchestra</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.pitture -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="pitture"
                  v-model="conteggiaInCostiTotali.pitture"
                  :checked="conteggiaInCostiTotali.pitture"
                  :change="aggiornaCostoTotale"
                  name="pitture"
                /> &nbsp &nbsp
                <label for="pitture" class="h5 mr-1"
                  >Pitture</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.regista -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="regista"
                  v-model="conteggiaInCostiTotali.regista"
                  :checked="conteggiaInCostiTotali.regista"
                  :change="aggiornaCostoTotale"
                  name="regista"
                /> &nbsp &nbsp
                <label for="regista" class="h5 mr-1"
                  >Regista</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.sarta -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="sarta"
                  v-model="conteggiaInCostiTotali.sarta"
                  :checked="conteggiaInCostiTotali.sarta"
                  :change="aggiornaCostoTotale"
                  name="sarta"
                /> &nbsp &nbsp
                <label for="sarta" class="h5 mr-1"
                  >Sarta</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.scenografo -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="scenografo"
                  v-model="conteggiaInCostiTotali.scenografo"
                  :checked="conteggiaInCostiTotali.scenografo"
                  :change="aggiornaCostoTotale"
                  name="scenografo"
                /> &nbsp &nbsp
                <label for="scenografo" class="h5 mr-1"
                  >Scenografo</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.siae -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="siae"
                  v-model="conteggiaInCostiTotali.siae"
                  :checked="conteggiaInCostiTotali.siae"
                  :change="aggiornaCostoTotale"
                  name="siae"
                /> &nbsp &nbsp
                <label for="siae" class="h5 mr-1"
                  >SIAE</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.sovratitoli -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="sovratitoli"
                  v-model="conteggiaInCostiTotali.sovratitoli"
                  :checked="conteggiaInCostiTotali.sovratitoli"
                  :change="aggiornaCostoTotale"
                  name="sovratitoli"
                /> &nbsp &nbsp
                <label for="sovratitoli" class="h5 mr-1"
                  >Sovratitoli</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.tersicorei -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="tersicorei"
                  v-model="conteggiaInCostiTotali.tersicorei"
                  :checked="conteggiaInCostiTotali.tersicorei"
                  :change="aggiornaCostoTotale"
                  name="tersicorei"
                /> &nbsp &nbsp
                <label for="tersicorei" class="h5 mr-1"
                  >Tersicorei</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.tintoria -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="tintoria"
                  v-model="conteggiaInCostiTotali.tintoria"
                  :checked="conteggiaInCostiTotali.tintoria"
                  :change="aggiornaCostoTotale"
                  name="tintoria"
                /> &nbsp &nbsp
                <label for="tintoria" class="h5 mr-1"
                  >Tintoria</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.trasportiFacchini -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="trasportiFacchini"
                  v-model="conteggiaInCostiTotali.trasportiFacchini"
                  :checked="conteggiaInCostiTotali.trasportiFacchini"
                  :change="aggiornaCostoTotale"
                  name="trasportiFacchini"
                /> &nbsp &nbsp
                <label for="trasportiFacchini" class="h5 mr-1"
                  >Trasporti e Facchini</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.truccoParrucco -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="truccoParrucco"
                  v-model="conteggiaInCostiTotali.truccoParrucco"
                  :checked="conteggiaInCostiTotali.truccoParrucco"
                  :change="aggiornaCostoTotale"
                  name="truccoParrucco"
                /> &nbsp &nbsp
                <label for="truccoParrucco" class="h5 mr-1"
                  >Trucco e Parrucco</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.vitto -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="vitto"
                  v-model="conteggiaInCostiTotali.vitto"
                  :checked="conteggiaInCostiTotali.vitto"
                  :change="aggiornaCostoTotale"
                  name="vitto"
                /> &nbsp &nbsp
                <label for="vitto" class="h5 mr-1"
                  >Vitto</label>
              </b-row>
            </b-col>
            <!-- Input di tipo checkbox: conteggiaInCostiTotali.voceRecitante -->
            <b-col xl="3" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <ejs-checkbox
                  id="voceRecitante"
                  v-model="conteggiaInCostiTotali.voceRecitante"
                  :checked="conteggiaInCostiTotali.voceRecitante"
                  :change="aggiornaCostoTotale"
                  name="voceRecitante"
                /> &nbsp &nbsp
                <label for="voceRecitante" class="h5 mr-1"
                  >Voce Recitante</label>
              </b-row>
            </b-col>



              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Costo Totale</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="costoTotale"
                  floatLabelType="Never"
                  cssClass=""
                  format="€ ###"
                  placeholder="Costo Azienda Totale"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col xl="12" md="12" v-show="showCostiRecita">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Costi a Recita</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Costo a Recita</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="tmpCosto"
                  floatLabelType="Never"
                  cssClass=""
                  format="€ ###"
                  placeholder="Costo Azienda Totale"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col xl="12" md="12" v-show="showCostiAllestimento">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Costi Allestimento</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <!-- Input di tipo checkbox: allestimentoMateriali -->
            <b-col xl="6" md="12" class="mb-2 align-items-center">
              <b-row class="m-0">
                <label for="allestimentoMateriali" class="h5 mr-1"
                  >Materiali</label
                >
                <ejs-checkbox
                  id="allestimentoMateriali"
                  v-model="allestimentoMateriali"
                  :checked="allestimentoMateriali"
                  :change="onAllestimentoMaterialiChange"
                  name="Materiali"
                />
              </b-row>
            </b-col>
            <b-row>
              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Totale Costi Allestimento</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="tmpCosto"
                  floatLabelType="Never"
                  cssClass=""
                  format="€ ###"
                  placeholder="Costo Azienda Totale"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col xl="12" md="12" v-show="showCostiArtistici">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Costi Artistici</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Totale Costi Artistici</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="tmpCosto"
                  floatLabelType="Never"
                  cssClass=""
                  format="€ ###"
                  placeholder="Costo Azienda Totale"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col xl="12" md="12" v-show="showAltriCosti">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Altri Costi</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Totale Altri Costi</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="tmpCosto"
                  floatLabelType="Never"
                  cssClass=""
                  format="€ ###"
                  placeholder="Costo Azienda Totale"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  LinkPlugin,
  AlertPlugin,
  ProgressPlugin,
  ToastPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Vuexy
// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(LayoutPlugin);
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(DropdownPlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(SpinnerPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiCostoSpettacoloRicercaUrl =
  "/demo/api/costoproduzioni/ricercaspettacolo";

const apiSpettacoloUrl = "/demo/api/spettacolo";

export default Vue.extend({
  components: {},
  data() {
    return {
      loading: false,
      // per gestione stagioni
      stagioniData: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      stagioniFields: { value: "val", text: "label" },
      stagioniIndex: -1,
      queryStagioni: null,
      querySpettacoli: null,
      stagioneCorrente: null,
      spettacoloCorrente: null,
      dropSpettacoliEnabled: false,
      // gestione elementi nascosti
      nonMostrare: false,

      // per gestione spettacoli
      elencoSpettacoliList: [],
      elencoSpettacoliFields: { value: "id", text: "titolo" },
      spettacoliIndex: -1,

      // generali
      settings: {
        formatoData: "dd-MM-yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
      },
      // CostoSpettacolo
      costoSpettacoloFullData: [], // elenco completo dati costoSpettacolo
      allestimentiSpettacoloFullData: [], // elenco completo dati costoSpettacolo
      scrittureSpettacoloFullData: [], // elenco completo dati costoSpettacolo
      costoSpettacoloActiveId: 0, // Id allestimento attivo (0 se nuovo)
      costoSpettacoloActiveData: {}, // dati completi dell allestimento attivo
      costoSpettacoloSavedData: {}, // dati completi dell allestimento attivo
      costoSpettacoloDefaultData: {}, // dati completi di default per nuovi costoSpettacolo

      tmpCosto: 0,
      showCostiSpettacolo: false,
      showRiepilogo: true,
      showCostiRecita: true,
      showCostiArtistici: true,
      showCostiAllestimento: true,
      showAltriCosti: true,
      costoSpettacoloActiveData: {
        // scritture
        aiutoSarta: 0,
        aiutoScenografo: 0,
        aiutoTruccoParrucco: 0,
        attrezzista: 0,
        cantanteLirico: 0,
        coreografo: 0,
        coro: 0,
        coroVociBianche: 0,
        corpoBallo: 0,
        costumista: 0,
        danzatore: 0,
        direttoreOrchestra: 0,
        direttoreScena: 0,
        drammaturgo: 0,
        elettricista: 0,
        ensembleOrchestrale: 0,
        figurante: 0,
        fonico: 0,
        librettista: 0,
        lighting: 0,
        macchinista: 0,
        maestroCollaboratore: 0,
        maestroCoro: 0,
        maestroSala: 0,
        maestroLuci: 0,
        maestroPalco: 0,
        maestroSovratitoli: 0,
        musicologo: 0,
        orchestra: 0,
        regista: 0,
        sarta: 0,
        scenografo: 0,
        sovratitoli: 0,
        tersicorei: 0,
        truccoParrucco: 0,
        voceRecitante: 0,
        dirittiCompositore: 0,
        dirittiCostumista: 0,
        dirittiLibrettista: 0,
        dirittiLighting: 0,
        dirittiRegia: 0,
        dirittiScenografo: 0,
        altriDiritti: 0,
        // allestimenti
        alloggio: 0,
        altro: 0,
        attrezzeria: 0,
        calzature: 0,
        costumi: 0,
        legname: 0,
        luci: 0,
        materialeElettrico: 0,
        materialeMusicale: 0,
        materialeConsumo: 0,
        pitture: 0,
        siae: 0,
        tintoria: 0,
        trasportiFacchini: 0,
        vitto: 0,
      },
      conteggiaInCostiTotali: {
        // scritture
        aiutoSarta: true,
        aiutoScenografo: true,
        aiutoTruccoParrucco: true,
        attrezzista: true,
        cantanteLirico: true,
        coreografo: true,
        coro: true,
        coroVociBianche: true,
        corpoBallo: true,
        costumista: true,
        danzatore: true,
        direttoreOrchestra: true,
        direttoreScena: true,
        drammaturgo: true,
        elettricista: true,
        ensembleOrchestrale: true,
        figurante: true,
        fonico: true,
        librettista: true,
        lighting: true,
        macchinista: true,
        maestroCollaboratore: true,
        maestroCoro: true,
        maestroSala: true,
        maestroLuci: true,
        maestroPalco: true,
        maestroSovratitoli: true,
        musicologo: true,
        orchestra: true,
        regista: true,
        sarta: true,
        scenografo: true,
        sovratitoli: true,
        tersicorei: true,
        truccoParrucco: true,
        voceRecitante: true,
        dirittiCompositore: true,
        dirittiCostumista: true,
        dirittiLibrettista: true,
        dirittiLighting: true,
        dirittiRegia: true,
        dirittiScenografo: true,
        altriDiritti: true,
        // allestimenti
        alloggio: true,
        altro: true,
        attrezzeria: true,
        calzature: true,
        costumi: true,
        legname: true,
        luci: true,
        materialeElettrico: true,
        materialeMusicale: true,
        materialeConsumo: true,
        pitture: true,
        siae: true,
        tintoria: true,
        trasportiFacchini: true,
        vitto: true,
      },
      allestimentoMateriali: true,

      costoTotale:0,

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per gridA
      // gridAFlag: false,
      // gridA: {
      //   height: 300,
      //   editOptions: {
      //     allowEditing: true,
      //     allowDeleting: true,
      //   },
      //   filterOptions: { type: "Excel" },
      // }, //
    };
  },
  created() {
    // log
    console.log("Pagina Costo Produzioni Creata");

    useJwt.get(apiSpettacoloUrl).then((d) => {
      console.log("Elenco Spettacoli");
      console.log(d.data);
      this.elencoSpettacoliList = d.data;
    });
  },
  mounted() {
    // disabilito gridA
    //this.$refs.gridA.$el.classList.add('disablegrid')
    //document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropStagioni
    this.$refs.dropStagioni.ej2Instances.focusIn();
  },

  provide: {
    // per grid
    //grid: [GridToolbar, GridSort, GridFilter, GridEdit],
  },
  methods: {
    // per dropdownlist combinate
    onStagioneChange: function (e) {
      this.loading = true;
      this.querySpettacoli = new Query().where(
        "stagione",
        "equal",
        this.$refs.dropStagioni.ej2Instances.value
      );
      this.dropSpettacoliEnabled = true;
      this.costoSpettacoloFullData = [];

      //this.$refs.gridA.$el.classList.remove('disablegrid');
      //document.getElementById("GridParent").classList.remove('wrapper');
    },

    onSpettacoloChange: function (e) {
      // abilito gridA
      //this.$refs.gridA.$el.classList.remove("disablegrid");
      //document.getElementById("GridParent").classList.remove("wrapper");
      // recupero elenco scritture dal backend
      if (localStorage.getItem("userData") !== null) {
        this.loading = true;
        console.log("Recupero elenco scritture dal backend");
        const datiDaInviare = {
          spettacolo: this.spettacoloCorrente,
        };
        if (datiDaInviare.spettacolo === null) {
          console.log("Spettacolo non ancora selezionato");
        } else {
          useJwt.post(apiCostoSpettacoloRicercaUrl, datiDaInviare).then((d) => {
            // gestione risposta
            // ottenere elenco costi dello spettacolo
            console.log(d.data);
            this.costoSpettacoloFullData = d.data;
            console.log("Info costo spettacolo");
            console.log(this.costoSpettacoloFullData);
            // smista costo spettacolo
            this.smistaCostoSpettacolo();

            this.loading = false;
          });
          // mostro le card relative ai costi spettacolo
          this.showCostiSpettacolo = true;
        }
      } else {
        console.log("Non trovo UserData, prova ancora");
      }
    },

    onAllestimentoMaterialiChange: function () {
      console.log("onAllestimentoMaterialiChange");
      this.showCostiArtistici = this.allestimentoMateriali;
    },


    aggiornaCostoTotale: function () {
      console.log("aggiornaCostoTotale");
      this.costoTotale=0;
      if(this.conteggiaInCostiTotali.aiutoSarta) {this.costoTotale+=this.costoSpettacoloActiveData.aiutoSarta}
      if(this.conteggiaInCostiTotali.aiutoScenografo) {this.costoTotale+=this.costoSpettacoloActiveData.aiutoScenografo}
      if(this.conteggiaInCostiTotali.aiutoTruccoParrucco) {this.costoTotale+=this.costoSpettacoloActiveData.aiutoTruccoParrucco}
      if(this.conteggiaInCostiTotali.alloggio) {this.costoTotale+=this.costoSpettacoloActiveData.alloggio}
      if(this.conteggiaInCostiTotali.altriDiritti) {this.costoTotale+=this.costoSpettacoloActiveData.altriDiritti}
      if(this.conteggiaInCostiTotali.altro) {this.costoTotale+=this.costoSpettacoloActiveData.altro}
      if(this.conteggiaInCostiTotali.attrezzeria) {this.costoTotale+=this.costoSpettacoloActiveData.attrezzeria}
      if(this.conteggiaInCostiTotali.attrezzista) {this.costoTotale+=this.costoSpettacoloActiveData.attrezzista}
      if(this.conteggiaInCostiTotali.calzature) {this.costoTotale+=this.costoSpettacoloActiveData.calzature}
      if(this.conteggiaInCostiTotali.cantanteLirico) {this.costoTotale+=this.costoSpettacoloActiveData.cantanteLirico}
      if(this.conteggiaInCostiTotali.coreografo) {this.costoTotale+=this.costoSpettacoloActiveData.coreografo}
      if(this.conteggiaInCostiTotali.coro) {this.costoTotale+=this.costoSpettacoloActiveData.coro}
      if(this.conteggiaInCostiTotali.coroVociBianche) {this.costoTotale+=this.costoSpettacoloActiveData.coroVociBianche}
      if(this.conteggiaInCostiTotali.corpoBallo) {this.costoTotale+=this.costoSpettacoloActiveData.corpoBallo}
      if(this.conteggiaInCostiTotali.costumi) {this.costoTotale+=this.costoSpettacoloActiveData.costumi}
      if(this.conteggiaInCostiTotali.costumista) {this.costoTotale+=this.costoSpettacoloActiveData.costumista}
      if(this.conteggiaInCostiTotali.danzatore) {this.costoTotale+=this.costoSpettacoloActiveData.danzatore}
      if(this.conteggiaInCostiTotali.direttoreOrchestra) {this.costoTotale+=this.costoSpettacoloActiveData.direttoreOrchestra}
      if(this.conteggiaInCostiTotali.direttoreScena) {this.costoTotale+=this.costoSpettacoloActiveData.direttoreScena}
      if(this.conteggiaInCostiTotali.dirittiCompositore) {this.costoTotale+=this.costoSpettacoloActiveData.dirittiCompositore}
      if(this.conteggiaInCostiTotali.dirittiCostumista) {this.costoTotale+=this.costoSpettacoloActiveData.dirittiCostumista}
      if(this.conteggiaInCostiTotali.dirittiLibrettista) {this.costoTotale+=this.costoSpettacoloActiveData.dirittiLibrettista}
      if(this.conteggiaInCostiTotali.dirittiLighting) {this.costoTotale+=this.costoSpettacoloActiveData.dirittiLighting}
      if(this.conteggiaInCostiTotali.dirittiRegia) {this.costoTotale+=this.costoSpettacoloActiveData.dirittiRegia}
      if(this.conteggiaInCostiTotali.dirittiScenografo) {this.costoTotale+=this.costoSpettacoloActiveData.dirittiScenografo}
      if(this.conteggiaInCostiTotali.drammaturgo) {this.costoTotale+=this.costoSpettacoloActiveData.drammaturgo}
      if(this.conteggiaInCostiTotali.elettricista) {this.costoTotale+=this.costoSpettacoloActiveData.elettricista}
      if(this.conteggiaInCostiTotali.ensembleOrchestrale) {this.costoTotale+=this.costoSpettacoloActiveData.ensembleOrchestrale}
      if(this.conteggiaInCostiTotali.figurante) {this.costoTotale+=this.costoSpettacoloActiveData.figurante}
      if(this.conteggiaInCostiTotali.fonico) {this.costoTotale+=this.costoSpettacoloActiveData.fonico}
      if(this.conteggiaInCostiTotali.legname) {this.costoTotale+=this.costoSpettacoloActiveData.legname}
      if(this.conteggiaInCostiTotali.librettista) {this.costoTotale+=this.costoSpettacoloActiveData.librettista}
      if(this.conteggiaInCostiTotali.lighting) {this.costoTotale+=this.costoSpettacoloActiveData.lighting}
      if(this.conteggiaInCostiTotali.luci) {this.costoTotale+=this.costoSpettacoloActiveData.luci}
      if(this.conteggiaInCostiTotali.macchinista) {this.costoTotale+=this.costoSpettacoloActiveData.macchinista}
      if(this.conteggiaInCostiTotali.maestroCollaboratore) {this.costoTotale+=this.costoSpettacoloActiveData.maestroCollaboratore}
      if(this.conteggiaInCostiTotali.maestroCoro) {this.costoTotale+=this.costoSpettacoloActiveData.maestroCoro}
      if(this.conteggiaInCostiTotali.maestroLuci) {this.costoTotale+=this.costoSpettacoloActiveData.maestroLuci}
      if(this.conteggiaInCostiTotali.maestroPalco) {this.costoTotale+=this.costoSpettacoloActiveData.maestroPalco}
      if(this.conteggiaInCostiTotali.maestroSala) {this.costoTotale+=this.costoSpettacoloActiveData.maestroSala}
      if(this.conteggiaInCostiTotali.maestroSovratitoli) {this.costoTotale+=this.costoSpettacoloActiveData.maestroSovratitoli}
      if(this.conteggiaInCostiTotali.materialeConsumo) {this.costoTotale+=this.costoSpettacoloActiveData.materialeConsumo}
      if(this.conteggiaInCostiTotali.materialeElettrico) {this.costoTotale+=this.costoSpettacoloActiveData.materialeElettrico}
      if(this.conteggiaInCostiTotali.materialeMusicale) {this.costoTotale+=this.costoSpettacoloActiveData.materialeMusicale}
      if(this.conteggiaInCostiTotali.musicologo) {this.costoTotale+=this.costoSpettacoloActiveData.musicologo}
      if(this.conteggiaInCostiTotali.orchestra) {this.costoTotale+=this.costoSpettacoloActiveData.orchestra}
      if(this.conteggiaInCostiTotali.pitture) {this.costoTotale+=this.costoSpettacoloActiveData.pitture}
      if(this.conteggiaInCostiTotali.regista) {this.costoTotale+=this.costoSpettacoloActiveData.regista}
      if(this.conteggiaInCostiTotali.sarta) {this.costoTotale+=this.costoSpettacoloActiveData.sarta}
      if(this.conteggiaInCostiTotali.scenografo) {this.costoTotale+=this.costoSpettacoloActiveData.scenografo}
      if(this.conteggiaInCostiTotali.siae) {this.costoTotale+=this.costoSpettacoloActiveData.siae}
      if(this.conteggiaInCostiTotali.sovratitoli) {this.costoTotale+=this.costoSpettacoloActiveData.sovratitoli}
      if(this.conteggiaInCostiTotali.tersicorei) {this.costoTotale+=this.costoSpettacoloActiveData.tersicorei}
      if(this.conteggiaInCostiTotali.tintoria) {this.costoTotale+=this.costoSpettacoloActiveData.tintoria}
      if(this.conteggiaInCostiTotali.trasportiFacchini) {this.costoTotale+=this.costoSpettacoloActiveData.trasportiFacchini}
      if(this.conteggiaInCostiTotali.truccoParrucco) {this.costoTotale+=this.costoSpettacoloActiveData.truccoParrucco}
      if(this.conteggiaInCostiTotali.vitto) {this.costoTotale+=this.costoSpettacoloActiveData.vitto}
      if(this.conteggiaInCostiTotali.voceRecitante) {this.costoTotale+=this.costoSpettacoloActiveData.voceRecitante}
      
    },

    // gridAactionBegin(e) {
    //   if (!this.gridAFlag) {
    //     // Add and edit operations
    //     if (e.requestType === "save") {
    //       const editedData = e.data;
    //       console.log(editedData);
    //       // The default edit operation is cancelled
    //       e.cancel = true;
    //       const editUrl = `${apiAllestimentiUrl}/${editedData.id}`;
    //       useJwt.patch(editUrl, editedData).then((res) => {
    //         console.log(res);
    //         if (res.status === 200) {
    //           // se tutto OK
    //           // Flag is enabled to skip this execution when grid ends add/edit
    //           this.gridAFlag = true;
    //           // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
    //           this.$refs.gridA.endEdit();
    //         } else {
    //           this.makeToast(
    //             "primary",
    //             "Attenzione",
    //             "Salvataggio allestimento non riuscito"
    //           );
    //         }
    //       });
    //     }
    //   }
    // },
    // // Grid’s actionComplete event handler
    // // Triggers after an action is completed
    // gridAactionComplete(e) {
    //   if (e.requestType === "save") {
    //     // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
    //     this.gridAFlag = false;
    //   }
    // },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
    smistaCostoSpettacolo() {
      console.log("Smistamento costo spettacolo");
      this.allestimentiSpettacoloFullData =
        this.costoSpettacoloFullData.allestimenti;
      //console.log(this.allestimentiSpettacoloFullData)
      this.scrittureSpettacoloFullData = this.costoSpettacoloFullData.scritture;
      // inizializzo i contatori di costo
      this.costoSpettacoloActiveData = {
        // scritture
        aiutoSarta: 0,
        aiutoScenografo: 0,
        aiutoTruccoParrucco: 0,
        attrezzista: 0,
        cantanteLirico: 0,
        coreografo: 0,
        coro: 0,
        coroVociBianche: 0,
        corpoBallo: 0,
        costumista: 0,
        danzatore: 0,
        direttoreOrchestra: 0,
        direttoreScena: 0,
        drammaturgo: 0,
        elettricista: 0,
        ensembleOrchestrale: 0,
        figurante: 0,
        fonico: 0,
        librettista: 0,
        lighting: 0,
        macchinista: 0,
        maestroCollaboratore: 0,
        maestroCoro: 0,
        maestroSala: 0,
        maestroLuci: 0,
        maestroPalco: 0,
        maestroSovratitoli: 0,
        musicologo: 0,
        orchestra: 0,
        regista: 0,
        sarta: 0,
        scenografo: 0,
        sovratitoli: 0,
        tersicorei: 0,
        truccoParrucco: 0,
        voceRecitante: 0,
        dirittiCompositore: 0,
        dirittiCostumista: 0,
        dirittiLibrettista: 0,
        dirittiLighting: 0,
        dirittiRegia: 0,
        dirittiScenografo: 0,
        altriDiritti: 0,
        // allestimenti
        alloggio: 0,
        altro: 0,
        attrezzeria: 0,
        calzature: 0,
        costumi: 0,
        legname: 0,
        luci: 0,
        materialeElettrico: 0,
        materialeMusicale: 0,
        materialeConsumo: 0,
        pitture: 0,
        siae: 0,
        tintoria: 0,
        trasportiFacchini: 0,
        vitto: 0,
      };
      // Gestione Allestimenti
      for (const allestimento of this.allestimentiSpettacoloFullData) {
        // usare for of e non for in
        console.log(allestimento.categoria);
        if (allestimento.categoria == "alloggio") {
          this.costoSpettacoloActiveData.alloggio += allestimento.importo;
        } else if (allestimento.categoria == "altro") {
          this.costoSpettacoloActiveData.altro += allestimento.importo;
        } else if (allestimento.categoria == "attrezzeria") {
          this.costoSpettacoloActiveData.attrezzeria += allestimento.importo;
        } else if (allestimento.categoria == "calzature") {
          this.costoSpettacoloActiveData.calzature += allestimento.importo;
        } else if (allestimento.categoria == "costumi") {
          this.costoSpettacoloActiveData.costumi += allestimento.importo;
        } else if (allestimento.categoria == "legname") {
          this.costoSpettacoloActiveData.legname += allestimento.importo;
        } else if (allestimento.categoria == "luci") {
          this.costoSpettacoloActiveData.luci += allestimento.importo;
        } else if (allestimento.categoria == "materialeElettrico") {
          this.costoSpettacoloActiveData.materialeElettrico += allestimento.importo;
        } else if (allestimento.categoria == "materialeMusicale") {
          this.costoSpettacoloActiveData.materialeMusicale += allestimento.importo;
        } else if (allestimento.categoria == "materialeConsumo") {
          this.costoSpettacoloActiveData.materialeConsumo += allestimento.importo;
        } else if (allestimento.categoria == "pitture") {
          this.costoSpettacoloActiveData.pitture += allestimento.importo;
        } else if (allestimento.categoria == "siae") {
          this.costoSpettacoloActiveData.siae += allestimento.importo;
        } else if (allestimento.categoria == "tintoria") {
          this.costoSpettacoloActiveData.tintoria += allestimento.importo;
        } else if (allestimento.categoria == "trasportiFacchini") {
          this.costoSpettacoloActiveData.trasportiFacchini += allestimento.importo;
        } else if (allestimento.categoria == "vitto") {
          this.costoSpettacoloActiveData.vitto += allestimento.importo;
        }
      }
      // Gestione Scritture
      for (const scrittura of this.scrittureSpettacoloFullData) {
        // usare for of e non for in
        console.log(scrittura.ruoloGenerale);
        if (scrittura.ruoloGenerale == "Aiuto Regia") {
          this.costoSpettacoloActiveData.aiutoRegia +=scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Aiuto Sarta") {
          this.costoSpettacoloActiveData.aiutoSarta += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Aiuto Scenografo") {
          this.costoSpettacoloActiveData.aiutoScenografo += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Aiuto Trucco e Parrucco") {
          this.costoSpettacoloActiveData.aiutoTruccoParrucco += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Attrezzista") {
          this.costoSpettacoloActiveData.attrezzista += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Cantante lirico") {
          this.costoSpettacoloActiveData.cantanteLirico += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Coreografo") {
          this.costoSpettacoloActiveData.coreografo += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Coro") {
          this.costoSpettacoloActiveData.coro += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Coro delle Voci Bianche") {
          this.costoSpettacoloActiveData.coroVociBianche += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Corpo di Ballo") {
          this.costoSpettacoloActiveData.corpoBallo += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Costumista") {
          this.costoSpettacoloActiveData.costumista += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Danzatore") {
          this.costoSpettacoloActiveData.danzatore += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Direttore d’Orchestra") {
          this.costoSpettacoloActiveData.direttoreOrchestra += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Direttore di Scena") {
          this.costoSpettacoloActiveData.direttoreScena += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Drammaturgo") {
          this.costoSpettacoloActiveData.drammaturgo += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Elettricista") {
          this.costoSpettacoloActiveData.elettricista += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Ensemble Orchestrale") {
          this.costoSpettacoloActiveData.ensembleOrchestrale += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Figurante") {
          this.costoSpettacoloActiveData.figurante += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Fonico") {
          this.costoSpettacoloActiveData.fonico += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Librettista") {
          this.costoSpettacoloActiveData.librettista += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Lighting") {
          this.costoSpettacoloActiveData.lighting += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Macchinista") {
          this.costoSpettacoloActiveData.macchinista += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Maestro Collaboratore") {
          this.costoSpettacoloActiveData.maestroCollaboratore += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Maestro del Coro") {
          this.costoSpettacoloActiveData.maestroCoro += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Maestro di Sala") {
          this.costoSpettacoloActiveData.maestroSala += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Maestro delle Luci") {
          this.costoSpettacoloActiveData.maestroLuci += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Maestro del Palco") {
          this.costoSpettacoloActiveData.maestroPalco += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Maestro dei Sovratitoli") {
          this.costoSpettacoloActiveData.maestroSovratitoli += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Musicologo") {
          this.costoSpettacoloActiveData.musicologo += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Orchestra") {
          this.costoSpettacoloActiveData.orchestra += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Regista") {
          this.costoSpettacoloActiveData.regista += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Sarta") {
          this.costoSpettacoloActiveData.sarta += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Scenografo") {
          this.costoSpettacoloActiveData.scenografo += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Tersicorei") {
          this.costoSpettacoloActiveData.tersicorei += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Trucco e Parrucco") {
          this.costoSpettacoloActiveData.truccoParrucco += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Voce Recitante") {
          this.costoSpettacoloActiveData.voceRecitante += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Diritti Compositore") {
          this.costoSpettacoloActiveData.dirittiCompositore += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Diritti Costumista") {
          this.costoSpettacoloActiveData.dirittiCostumista += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Diritti Librettista") {
          this.costoSpettacoloActiveData.dirittiLibrettista += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Diritti Lighting") {
          this.costoSpettacoloActiveData.dirittiLighting += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Diritti Regia") {
          this.costoSpettacoloActiveData.dirittiRegia += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Diritti Scenografo") {
          this.costoSpettacoloActiveData.dirittiScenografo += scrittura.costo_azienda_totale;
        } else if (scrittura.ruoloGenerale == "Altri Diritti") {
          this.costoSpettacoloActiveData.altriDiritti += scrittura.costo_azienda_totale;
        }
         
      }
      // Plot costi spettacolo aggiornati
      console.log("Costi Aggiornati");
      console.log(this.costoSpettacoloActiveData);

      // aggiornamento costi totali
      this.aggiornaCostoTotale()
    },
  },
  computed: {
    // hasChanged() {
    //   // console.log(this.allestimentiActiveData)
    //   // console.log(this.allestimentiSavedData)
    //   return Object.keys(this.allestimentiActiveData).some(
    //     (field) =>
    //       this.allestimentiActiveData[field] !==
    //       this.allestimentiSavedData[field]
    //   );
    // },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import "~@syncfusion/ej2-schedule/styles/material.css";
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
